export default __webpack_public_path__ + "static/media/linkedin.7c3f334f.png";